
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import PLApplicationActivitiesTimelineItem from "./PLApplicationActivitiesTimelineItem.vue";
interface PLApplicationActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "PLApplicationAllActivities",
  components: { PLApplicationActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): PLApplicationActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_PL_APPLICATION_FAILURE,
          ADD_PL_APPLICATION_SUCCESS,
          UPDATE_PL_APPLICATION_FAILURE,
          UPDATE_PL_APPLICATION_SUCCESS,
          DELETE_PL_APPLICATION_SUCCESS,
          DELETE_PL_APPLICATION_FAILURE
          `.replace(/\s/g, ""),
        activityType: "PLApplicationActivity"
      };
    }
  }
});
